export const environment = {
  production: false,
  coreApiUrl: 'https://portal-stage.goatness.app/api',
  authorityApiUrl: 'https://login-stage.goatness.app/api',
  authorityPortalUrl: 'https://login-stage.goatness.app',
  sentryDSN:
    'https://552e5c53a2de0e066be6092ef393e41c@o4507419812102144.ingest.de.sentry.io/4507419863089232',
  sentryEnvironment: 'stage',
  publishableKey:
    'pk_test_51NAua1CQPPfNtQ22B7JoppN7ivpfqmBp8GM322iHCLDZPqrEXOazj0s7IMc9tFX170lzRq3ffAuVHNZ91YuzrXdy00m1hFshqF',
};
